/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Variable_Details_Module_LabelInputs */



/**
* | output |
* | --- |
* | "AHUs per module" |
*
* @param {Variable_Details_Module_LabelInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const variable_details_module_label = /** @type {((inputs?: Variable_Details_Module_LabelInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Variable_Details_Module_LabelInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("AHUs per module")
	return /** @type {LocalizedString} */ ("CTA par module")
});